module.exports = __webpack_public_path__ + "static/media/goal_lost_img.7a7ee1b2.png";